import * as React from 'react'

import Svg, { G, Mask, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Chat = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    {...props}
  >
    <Mask
      id="a"
      width={24}
      height={24}
      x={4}
      y={4}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <Path fill="#D9D9D9" d="M4 4h24v24H4z" />
    </Mask>
    <G mask="url(#a)">
      <Path
        fill={color}
        d="m16 26-.25-3h-.25c-2.367 0-4.375-.825-6.025-2.475C7.825 18.875 7 16.867 7 14.5c0-2.367.825-4.375 2.475-6.025C11.125 6.825 13.133 6 15.5 6a8.28 8.28 0 0 1 3.313.662 8.585 8.585 0 0 1 4.524 4.526A8.28 8.28 0 0 1 24 14.5c0 1.25-.204 2.45-.613 3.6a12.739 12.739 0 0 1-1.675 3.2 14.164 14.164 0 0 1-2.524 2.675A15.65 15.65 0 0 1 16 26Zm2-3.65c1.183-1 2.146-2.17 2.887-3.513A8.822 8.822 0 0 0 22 14.5c0-1.817-.63-3.354-1.887-4.613C18.854 8.63 17.317 8 15.5 8c-1.817 0-3.354.63-4.613 1.887C9.63 11.146 9 12.683 9 14.5c0 1.817.63 3.354 1.887 4.613C12.146 20.37 13.683 21 15.5 21H18v1.35Zm-2.525-2.375c.283 0 .525-.1.725-.3.2-.2.3-.442.3-.725s-.1-.525-.3-.725c-.2-.2-.442-.3-.725-.3s-.525.1-.725.3c-.2.2-.3.442-.3.725s.1.525.3.725c.2.2.442.3.725.3ZM14.75 16.8h1.5c0-.5.05-.85.15-1.05.1-.2.417-.567.95-1.1.3-.3.55-.625.75-.975.2-.35.3-.725.3-1.125 0-.85-.287-1.488-.862-1.913-.576-.425-1.255-.637-2.038-.637-.733 0-1.35.204-1.85.613-.5.408-.85.904-1.05 1.487l1.4.55c.083-.283.242-.563.475-.838.233-.274.575-.412 1.025-.412.45 0 .788.125 1.012.375.226.25.338.525.338.825 0 .283-.083.537-.25.763a6.204 6.204 0 0 1-.6.687c-.583.5-.938.896-1.063 1.188-.124.291-.187.812-.187 1.562Z"
      />
    </G>
  </Svg>
)
export default Chat
